export type OptimizeConfig = {
    ABConfig: ScreenOrder;
    componentText: MessageProperties;
    componentVisibility: FieldVisibility;
    showPartnersWithLines: boolean;
    showPartnerNavigationOnMobile: boolean;
    showLoanConfigurationWithBorderedInput: boolean;
};

type ScreenOrder = {
    ScreenOrder: ScreenOrderItem[];
};

type ScreenOrderItem = {
    id: string;
    fields: string[];
};

export type MessageProperties = {
    loanConfigurationTitle: string;
    loanConfigurationTitleReceivables: string;
    loanConfigurationTitleRejected: string;
};

export type FieldVisibility = {
    loanReasonDescription: boolean;
    aboutCompanyAdvice: boolean;
};

export const defaultOptimizeConfig: OptimizeConfig = {
    ABConfig: null,
    showPartnerNavigationOnMobile: true,
    showPartnersWithLines: false,
    showLoanConfigurationWithBorderedInput: false,
    componentText: {
        loanConfigurationTitle: 'temos um valor pré-aprovado!',
        loanConfigurationTitleReceivables:
            'seu crédito foi aprovado na modalidade Garantia de Recebíveis!',
        loanConfigurationTitleRejected:
            'Não conseguimos incluir seu crédito na modalidade de Garantia de Recebíveis, mas temos outra oferta pra você',
    },
    componentVisibility: {
        loanReasonDescription: true,
        aboutCompanyAdvice: false,
    },
};
